import { useTranslation } from "react-i18next";
import {
  ButtonProps,
  getButtons,
  getInfoFields,
  InfoFieldsProps,
} from "../Layout/Layout";
import "./AdditionalInfo.scss";

interface AdditionalInfoProps {
  infoFields: Array<InfoFieldsProps>;
  buttons?: Array<ButtonProps>;
}

export default function AdditionalInfo(props: AdditionalInfoProps) {
  const { t } = useTranslation();

  return (
    <div className="d-flex justify-content-between bg-white border-bottom additional-info-component">
      <div>
        {getInfoFields(
          props.infoFields,
          "d-flex flex-direction-row flex-wrap text-gray-6 ps-114-rem pt-228-rem pb-25-rem",
          "container ps-0 pe-086-rem d-flex align-items-center"
        )}
      </div>
      {props.buttons &&
        getButtons(
          props.buttons,
          "pt-228-rem pe-171-rem pe-md-d-1-rem",
          "ms-3",
          t
        )}
    </div>
  );
}
